export default __webpack_public_path__ + "static/media/_carinereis.29790615.jpg";